import React, { useContext, useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import "../../../assets/css/gcstaff/staffnotespage/MyNotesPage.css";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext";
import Pagination from "../../../components/general/pagination/Pagination";
import Loader from "../../../components/general/loader/Loader";

/* ── Upload Modal ── */
const UploadModal = ({ onClose, onUploadSuccess }) => {
  const [visible, setVisible] = useState(false);
  const [form, setForm] = useState({
    title: "",
    subject: "",
    file: null,
    fileName: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const fileRef = useRef(null);
  const { baseUrl, loggedInUser, authToken, regExpChecker, validateTeacherNotesForm } = useContext(AppContext);
  useEffect(() => {
    setTimeout(() => setVisible(true), 30);
  }, []);
  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 260);
  };
  const set = (key) => (e) => {

    const value = e.target.value;

    setForm(prev => ({
        ...prev,
        [key]: value
    }));

    if (key === "title") {

        setErrors(prev => ({
            ...prev,
            title: regExpChecker("noteTitle", value)
        }));

    }

    if (key === "subject") {

        setErrors(prev => ({
            ...prev,
            subject: regExpChecker("subject", value)
        }));

    }

};

  const handleFile = (e) => {

    const f = e.target.files[0];

    if (f) {

        setForm(prev => ({
            ...prev,
            file: f,
            fileName: f.name
        }));

        setErrors(prev => ({
            ...prev,
            pdfFile: ""
        }));

    }

};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.title || !form.subject || !form.file) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill all fields and select a PDF file.",
      });
      return;
    }
    const validationErrors = validateTeacherNotesForm({
    title: form.title,
    subject: form.subject,
    pdfFile: form.file
});

setErrors(validationErrors);

if (Object.keys(validationErrors).length > 0) {
    return;
}

    if (!loggedInUser?.id) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Your session expired. Please log in again.",
      });
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("subject", form.subject);
    formData.append("pdf_file", form.file);
    formData.append("Lbteacher_id", loggedInUser.id);

    axios
      .post(`${baseUrl}/teacher/notes/uploadNote`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((res) => {
        setLoading(false);
        console.log("Upload response:", res.data);
        if (res.data.success === true) {
          Swal.fire({
            icon: "success",
            title: "Uploaded!",
            text: "Note uploaded successfully.",
            confirmButtonText: "Great",
          });
          onUploadSuccess();
          handleClose();
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: res.data.message || "Upload failed.",
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Upload error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again.",
        });
      });
  };

  return (
    <div
      className={`gcNote-backdrop ${visible ? "gcNote-backdrop--in" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`gcNote-modal ${visible ? "gcNote-modal--in" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="gcNote-modal-header">
          <h5 className="gcNote-modal-title">Upload New Notes</h5>
          <button className="gcNote-modal-close" onClick={handleClose}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
        <form onSubmit={handleSubmit} className="gcNote-modal-body gcNote-form">
          <div className="gcNote-form-group">
            <label className="gcNote-form-label">Title</label>

<input
  className="gcNote-form-input"
  type="text"
  placeholder="Note title"
  value={form.title}
  onChange={set("title")}
  required
/>

{errors.title && (
    <small className="text-danger">{errors.title}</small>
)}
          </div>
          <div className="gcNote-form-group">
            <label className="gcNote-form-label">Subject</label>

<input
  className="gcNote-form-input"
  type="text"
  placeholder="e.g. Data Structures"
  value={form.subject}
  onChange={set("subject")}
  required
/>

{errors.subject && (
    <small className="text-danger">{errors.subject}</small>
)}
          </div>
          <div className="gcNote-form-group">
            <label className="gcNote-form-label">PDF File</label>
            <div
              className="gcNote-upload-zone"
              onClick={() => fileRef.current?.click()}
            >
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path
                  d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinejoin="round"
                />
                <path
                  d="M14 2v6h6M12 12v6M9 15l3-3 3 3"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p className="gcNote-upload-text">
                {form.fileName || "Click to upload PDF"}
              </p>
              <p className="gcNote-upload-hint">PDF only (max 10MB)</p>
            </div>
            <input
    ref={fileRef}
    type="file"
    accept=".pdf"
    style={{ display: "none" }}
    onChange={handleFile}
/>

{errors.pdfFile && (
    <small className="text-danger">{errors.pdfFile}</small>
)}
          </div>
          <div className="gcNote-form-btns">
            <button
              type="submit"
              className="gcNote-save-btn"
              disabled={loading}
            >
              {loading ? "Uploading..." : "Upload Notes"}
            </button>
            <button
              type="button"
              className="gcNote-cancel-btn"
              onClick={handleClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

/* ── Edit Modal ── */
const EditModal = ({ note, onClose, onEditSuccess }) => {
  const [visible, setVisible] = useState(false);
  const [form, setForm] = useState({
    title: note.title,
    subject: note.subject,
  });
  const [loading, setLoading] = useState(false);
  const fileRef = useRef(null);
  const [newFile, setNewFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const { baseUrl, authToken } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => setVisible(true), 30);
  }, []);
  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 260);
  };
  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const handleFile = (e) => {
    const f = e.target.files[0];
    if (f) {
      setNewFile(f);
      setFileName(f.name);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    loading || setLoading(true);

    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("subject", form.subject);
    if (newFile) formData.append("pdf_file", newFile);

    axios
      .post(`${baseUrl}/teacher/notes/updateNote/${note.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((res) => {
        setLoading(false);
        console.log("Update response:", res.data);
        if (res.data.success === true) {
          Swal.fire({
            icon: "success",
            title: "Updated!",
            text: "Note updated successfully.",
            confirmButtonText: "OK",
          });
          onEditSuccess();
          handleClose();
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: res.data.message || "Update failed.",
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Update error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again.",
        });
      });
  };

  return (
    <div
      className={`gcNote-backdrop ${visible ? "gcNote-backdrop--in" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`gcNote-modal ${visible ? "gcNote-modal--in" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="gcNote-modal-header">
          <h5 className="gcNote-modal-title">Edit Note</h5>
          <button className="gcNote-modal-close" onClick={handleClose}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
        <form onSubmit={handleSubmit} className="gcNote-modal-body gcNote-form">
          <div className="gcNote-form-group">
            <label className="gcNote-form-label">Title</label>
            <input
              className="gcNote-form-input"
              type="text"
              value={form.title}
              onChange={set("title")}
              required
            />
          </div>
          <div className="gcNote-form-group">
            <label className="gcNote-form-label">Subject</label>
            <input
              className="gcNote-form-input"
              type="text"
              value={form.subject}
              onChange={set("subject")}
              required
            />
          </div>
          <div className="gcNote-form-group">
            <label className="gcNote-form-label">Replace PDF (optional)</label>
            <div
              className="gcNote-upload-zone"
              onClick={() => fileRef.current?.click()}
            >
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path
                  d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinejoin="round"
                />
                <path
                  d="M14 2v6h6M12 12v6M9 15l3-3 3 3"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p className="gcNote-upload-text">
                {fileName || "Click to replace PDF"}
              </p>
              <p className="gcNote-upload-hint">
                Leave empty to keep existing file
              </p>
            </div>
            <input
              ref={fileRef}
              type="file"
              accept=".pdf"
              style={{ display: "none" }}
              onChange={handleFile}
            />
          </div>
          <div className="gcNote-form-btns">
            <button
              type="submit"
              className="gcNote-save-btn"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Changes"}
            </button>
            <button
              type="button"
              className="gcNote-cancel-btn"
              onClick={handleClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

/* ── Delete Modal ── */
const DeleteModal = ({ note, onClose, onDeleteSuccess }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { baseUrl, authToken } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => setVisible(true), 30);
  }, []);
  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 260);
  };

  const handleConfirm = () => {
    setLoading(true);
    axios
      .delete(`${baseUrl}/teacher/notes/deleteNote/${note.id}`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        setLoading(false);
        console.log("Delete response:", res.data);
        if (res.data.success === true) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Note deleted successfully.",
            confirmButtonText: "OK",
          });
          onDeleteSuccess();
          handleClose();
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: res.data.message || "Delete failed.",
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Delete error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again.",
        });
      });
  };

  return (
    <div
      className={`gcNote-backdrop ${visible ? "gcNote-backdrop--in" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`gcNote-modal gcNote-modal--sm ${visible ? "gcNote-modal--in" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="gcNote-delete-icon">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
            <path
              d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"
              stroke="#e03e3e"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h5 className="gcNote-delete-title">Delete Note?</h5>
        <p className="gcNote-delete-msg">
          Are you sure you want to delete <strong>"{note.title}"</strong>? This
          cannot be undone.
        </p>
        <div className="gcNote-delete-actions">
          <button className="gcNote-cancel-btn" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="gcNote-delete-confirm-btn"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Main Page
══════════════════════════════════════════ */
const ITEMS_PER_PAGE = 10; // yahan se page size control hoti hai

const MyNotesPage = () => {
  const [notes, setNotes] = useState([]);
  const [search, setSearch] = useState("");
  const [pageIn, setPageIn] = useState(false);
  const [rowVisible, setRowVisible] = useState([]);
  const [editNote, setEditNote] = useState(null);
  const [deleteNote, setDeleteNote] = useState(null);
  const [showUpload, setShowUpload] = useState(false);
  const [loading, setLoading] = useState(false);     // initial notes load
  const [viewLoading, setViewLoading] = useState(false); // page-switch / search loading (sirf visible rows k liye)
  const [currentPage, setCurrentPage] = useState(1); // pagination state
  const { baseUrl, baseUrlForFiles, loggedInUser, authToken } = useContext(AppContext);

  // Pehli render par view-loading trigger na ho, is liye ref se track kar rahe hain
  const isFirstRender = useRef(true);

  useEffect(() => {
    setTimeout(() => setPageIn(true), 60);
  }, []);

  // ── Load All Notes ──
  const loadAllNotes = () => {
    if (!loggedInUser?.id) {
      console.error("Teacher not logged in");
      return;
    }

    setLoading(true);

    axios
      .get(`${baseUrl}/teacher/notes/loadAllNotes/${loggedInUser.id}`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        console.log("Load notes response:", res.data);
        if (res.data.success === true) {
          setNotes(res.data.notes);
        }
      })
      .catch((error) => {
        console.error("Load notes error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (loggedInUser?.id) {
      loadAllNotes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInUser]);

  const filtered = notes.filter(
    (n) =>
      n.title.toLowerCase().includes(search.toLowerCase()) ||
      n.subject.toLowerCase().includes(search.toLowerCase()),
  );

  /* ── Pagination slice (sirf current page ka data table ko jayega) ── */
  const paginatedNotes = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  /* ── Search change hone par page 1 pe reset ── */
  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  /* ── Sirf visible rows ki loading dikhayein:
     - Jab search query change ho
     - Jab pagination se dusre page par jayen
     Loader khatam hone k baad hi row-stagger animation start hoti hai
     (neeche wale effect mein), is liye poori list ek sath "pop" nahi hoti. ── */
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setRowVisible([]);
    setViewLoading(true);
    const timer = setTimeout(() => setViewLoading(false), 400);
    return () => clearTimeout(timer);
  }, [search, currentPage]);

  /* ── Row-by-row stagger animation — sirf jab view-loading khatam ho ── */
  useEffect(() => {
    if (viewLoading) return;
    setRowVisible([]);
    const timeouts = paginatedNotes.map((_, i) => {
      return setTimeout(() => {
        setRowVisible((prev) => {
          const a = [...prev];
          a[i] = true;
          return a;
        });
      }, i * 65);
    });
    return () => timeouts.forEach((t) => clearTimeout(t));
    // eslint-disable-next-line
  }, [viewLoading, notes]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    return new Date(dateStr).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div className={`gcNote-page ${pageIn ? "gcNote-page--in" : ""}`}>
      <Container fluid className="gcNote-container">
        {/* ── Header ── */}
        <div className="gcNote-header">
          <h2 className="gcNote-title">My Notes</h2>
          <button
            className="gcNote-upload-btn"
            onClick={() => setShowUpload(true)}
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 5v14M5 12h14"
                stroke="currentColor"
                strokeWidth="2.3"
                strokeLinecap="round"
              />
            </svg>
            Upload New Notes
          </button>
        </div>

        {/* ── Search ── */}
        <div className="gcNote-search-row">
          <div className="gcNote-search-wrap">
            <input
              className="gcNote-search-input"
              type="text"
              placeholder="Search notes..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
            <button className="gcNote-search-btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="11"
                  cy="11"
                  r="7"
                  stroke="currentColor"
                  strokeWidth="1.9"
                />
                <path
                  d="M21 21l-4.35-4.35"
                  stroke="currentColor"
                  strokeWidth="1.9"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* ── Initial Loading (poora page pehli baar load ho raha hai) ── */}
        {loading && <Loader message="Notes loading, Please wait..." />}

        {/* ── Table ── */}
        {!loading && (
          <>
            {viewLoading ? (
              /* ── Page/search switch loading — sirf table body ki, baaki page affect nahi hota ── */
              <Loader message="Loading notes..." />
            ) : (
              <div className="gcNote-table-wrap">
                <table className="gcNote-table">
                  <thead>
                    <tr>
                      <th className="gcNote-th">Title</th>
                      <th className="gcNote-th">Subject</th>
                      <th className="gcNote-th">Date</th>
                      <th className="gcNote-th">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedNotes.map((note, i) => (
                      <tr
                        key={note.id}
                        className={`gcNote-tr ${rowVisible[i] ? "gcNote-tr--in" : ""}`}
                        style={{ transitionDelay: `${i * 0.05}s` }}
                      >
                        <td className="gcNote-td">
                          <div className="gcNote-title-cell">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              className="gcNote-file-icon"
                            >
                              <path
                                d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
                                stroke="currentColor"
                                strokeWidth="1.7"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M14 2v6h6M9 13h6M9 17h4"
                                stroke="currentColor"
                                strokeWidth="1.7"
                                strokeLinecap="round"
                              />
                            </svg>
                            <span className="gcNote-note-title">{note.title}</span>
                          </div>
                        </td>
                        <td className="gcNote-td">
                          <span className="gcNote-subject-badge">{note.subject}</span>
                        </td>
                        <td className="gcNote-td gcNote-td--date">
                          {formatDate(note.created_at)}
                        </td>
                        <td className="gcNote-td">
                          <div className="gcNote-actions">
                            <a
                              href={`${baseUrlForFiles}/notes/${note.pdf_file}`}
                              target="_blank"
                              rel="noreferrer"
                              className="gcNote-action-btn gcNote-action-btn--view"
                              title="View PDF"
                            >
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                                  stroke="currentColor"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                />
                                <circle
                                  cx="12"
                                  cy="12"
                                  r="3"
                                  stroke="currentColor"
                                  strokeWidth="1.8"
                                />
                              </svg>
                            </a>
                            <button
                              className="gcNote-action-btn gcNote-action-btn--edit"
                              onClick={() => setEditNote(note)}
                              title="Edit"
                            >
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
                                  stroke="currentColor"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                />
                                <path
                                  d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                                  stroke="currentColor"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                            <button
                              className="gcNote-action-btn gcNote-action-btn--delete"
                              onClick={() => setDeleteNote(note)}
                              title="Delete"
                            >
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"
                                  stroke="currentColor"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {filtered.length === 0 && (
                      <tr>
                        <td colSpan={4} className="gcNote-td gcNote-td--empty">
                          No notes found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* ── Pagination (view-loading k dauran bhi visible rehti hai) ── */}
            <Pagination
              currentPage={currentPage}
              totalItems={filtered.length}
              itemsPerPage={ITEMS_PER_PAGE}
              onPageChange={setCurrentPage}
            />
          </>
        )}
      </Container>

      {/* Modals */}
      {showUpload && (
        <UploadModal
          onClose={() => setShowUpload(false)}
          onUploadSuccess={loadAllNotes}
        />
      )}
      {editNote && (
        <EditModal
          note={editNote}
          onClose={() => setEditNote(null)}
          onEditSuccess={loadAllNotes}
        />
      )}
      {deleteNote && (
        <DeleteModal
          note={deleteNote}
          onClose={() => setDeleteNote(null)}
          onDeleteSuccess={loadAllNotes}
        />
      )}
    </div>
  );
};

export default MyNotesPage;